/* eslint-disable */
import { useState, useEffect } from "react";
import { Form, Field, useFormState } from "react-final-form";
import DatePicker from "react-datepicker";
import Select from "react-select";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import useCustomerHook from "../customers/useCustomerHook";
import AddPaymentForm from "./components/form";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const EditPayment = () => {
  const [menu, setMenu] = useState(false);
  const { customers } = useCustomerHook();
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { id } = useParams();
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    // Extract payment ID from URL, e.g., /payments/edit/:id

    const fetchPayment = async () => {
      try {
        const response = await fetch(`/payments/api/${id}/`, {
          credentials: "include",
          headers: {
            "X-CSRFToken": document.cookie
              .split("; ")
              .find((row) => row.startsWith("csrftoken="))
              ?.split("=")[1],
          },
        });
        if (!response.ok) throw new Error("Failed to fetch payment");
        const data = await response.json();
        setPayment(data);
      } catch (error) {
        console.error("Error fetching payment:", error);
      }
    };

    fetchPayment();
  }, []);
  console.log("payment", payment);
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Payments</h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <AddPaymentForm
                    customers={customers}
                    isEdit={true}
                    paymentDetails={payment}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPayment;
